// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-group{position:relative;z-index:5;margin-left:1.35417vw;margin-top:6.2037vh;width:24.27083vw;height:85.64815vh;padding:.92593vh 1.25vw;box-sizing:border-box;background:rgba(4,26,29,.67);background-size:100% 100%;pointer-events:auto}", ""]);
// Exports
module.exports = exports;
